/*
 * @Author: zhujian 
 * @Date: 2018-02-26 17:51:03 
 * @Last Modified by: zhujian
 * @Last Modified time: 2018-09-03 17:00:13
 * 绑卡
 */

import React from 'react';
import { message, Modal } from 'antd';
import './BindCardModal.less';
// import Bus from '@/core/bus';
import AxiosTS from '../../core/axios';

const card = require('../../images/card/card.png');
const errorCard = require('../../images/card/error.png');
const successCard = require('../../images/card/success.png');

class BindCardModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      status: 0
    }
  }

  componentDidMount() {
    setTimeout(() => {
      this.refs.cardInput.focus();
    }, 1)
  }

  inputBlur = () => {
    if (window.playingCard) {
      return;
    }
    setTimeout(() => {
      if (this.refs.cardInput) {
        this.refs.cardInput.focus();
      }
    }, 10)
  }

  setStudentCard(cardId) {
    const studentId = this.props.studentId;
    AxiosTS.Business('public/attendance/bindCard', {
      cardId,
      studentId,
    }, {
      reject: true
    }).then((res) => {
      if (res.result) {
        message.success('绑定成功');
        this.setState({ status: 1 }, () => {
          this.props.success();
        })
      } else {
        message.error('绑定失败');
      }
    }, (res) => {
      this.setState({ status: 2 }, () => {
        setTimeout(() => {
          this.setState({ status: 0 })
        }, 2000)
      })
    })

  }

  palyCard = (e) => {
    if (!e.target.value) {
      return
    };
    clearTimeout(this.timer);
    let val = e.target.value + '';
    this.timer = setTimeout(() => {
      if (val.length < 5) {
        message.warning('卡号不得少于5位');
        this.refs.cardInput.value = '';
        return
      }
      // if (!window.CONFIG.isWindows) {
      //   message.warning('刷卡机仅支持在Windows系统的电脑上使用');
      //   this.refs.cardInput.value = '';
      //   return;
      // }
      val = parseInt(val) + '';
      this.setStudentCard(val);
      this.refs.cardInput.value = '';
    }, 80)
  }

  render() {
    return (
      <Modal
        className="bind-card"
        width={400}
        onCancel={this.props.close}
        title={'绑定卡片'}
        visible={true}
        footer={null}
      >
        <input type="text" className='card-input' ref='cardInput' onBlur={this.inputBlur} onChange={this.palyCard} />
        <div className="img">
          {
            this.state.status === 0 && <img src={card} alt="" />
          }
          {
            this.state.status === 0 && <p >请刷卡</p>

          }
          {
            this.state.status === 1 && <img src={successCard} className='play' alt="" />
          }
          {
            this.state.status === 2 && <img src={errorCard} className='play' alt="" />
          }
          {
            this.state.status === 2 && <p >绑定失败，请重新刷卡</p>
          }

        </div>
      </Modal>
    )
  }
}

export default BindCardModal;

